import React from 'react';
import BtnTop from "../BtnTop";
import { useFilter } from "../../pages/Marketplace/FilterContext";
import logo from '../../img/main_logo_white.png'
import './Footer.scss';
import { marketplaceMenu, verticalsMenu, informationMenu } from './menuData';

const Footer = () => {
    const filters = useFilter();
    return (
        <div className="section-footer">
            <div className="footer-top">
                <div className="coll">
                    <h3>Marketplace</h3>
                    <ul>
                        {marketplaceMenu.map(item => (
                            <li key={item.id}>
                                <div className='link' onClick={() => filters.handleCategoryChange(item.id)}>{item.label}</div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="coll">
                    <h3>Verticals</h3>
                    <ul>
                        {verticalsMenu.map(item => (
                            <li key={item.href}>
                                <a href={item.href}>{item.label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="coll">
                    <h3>Information</h3>
                    <ul>
                        {informationMenu.map(item => (
                            <li key={item.href}>
                                <a href={item.href}>{item.label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="logo link">
                    <img src={logo} alt="logo"/>
                </div>
                <div className="text">
                    Copyright &copy; iDitty inc 2024 - All Rights Reserved
                </div>
            </div>
            <BtnTop/>
        </div>
    );
};

export default Footer;